/* Mug release: keychain cross-sell inside the Rebuy Smart Cart drawer. Site-wide, but inert unless
   the cart holds one of the release cups. Offers only keychains not already in the cart; hides
   entirely once both are in. Defensive: any failure leaves the Rebuy cart untouched. */
(function () {
  'use strict';
  var C = window.MUG_RELEASE;
  if (!C || !C.keychains || !C.keychains.length || !window.fetch) return;
  var mugIds = C.mugVariantIds || [];
  var params = new URLSearchParams(location.search);
  var role = window.Shopify && Shopify.theme && Shopify.theme.role;
  var preview = role && role !== 'main' ? (params.get('mr_preview') || '').split(',') : [];

  var css = '.mr-cx{margin:14px 16px 6px;padding:14px 14px 6px;background:#FBF8F2;border:1px solid #D9CFBF;border-top:3px solid #A8884B;font-family:Lato,"Helvetica Neue",Arial,sans-serif;color:#1A1714}' +
    '.mr-cx-h{font:600 11px/1.4 Lato,Arial,sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#8A663A;margin:0 0 2px}' +
    '.mr-cx-s{font:400 13px/1.4 Lato,Arial,sans-serif;color:#4A433C;margin:0 0 8px}' +
    '.mr-cx-row{display:grid;grid-template-columns:52px 1fr auto;gap:4px 10px;align-items:center;padding:8px 0;border-top:1px solid #E6DDCF}' +
    '.mr-cx-row img{width:52px;height:52px;object-fit:cover;background:#fff;grid-row:span 2}' +
    '.mr-cx-n{font:600 13px/1.3 Lato,Arial,sans-serif}' +
    '.mr-cx-p{font:400 12px/1.3 Lato,Arial,sans-serif;color:#4A433C}.mr-cx-p s{margin-left:4px}' +
    '.mr-cx-row select{grid-column:2;height:32px;font:400 12px/1 Lato,Arial,sans-serif;border:1px solid #BDB2A0;background:#fff;border-radius:0;max-width:100%;color:#1A1714}' +
    '.mr-cx-b{grid-column:3;grid-row:1/span 2;min-height:36px;padding:0 12px;border:1px solid #013259;background:#fff;color:#013259;font:700 11px/1 Lato,Arial,sans-serif;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}' +
    '.mr-cx-b:hover{background:#013259;color:#fff}.mr-cx-b[disabled]{opacity:.6;cursor:progress}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function offerActive() {
    if (preview.indexOf('offer') > -1 || preview.indexOf('sale') > -1) return true;
    var o = C.offer || {}; if (!o.live) return false;
    var n = Date.now(); return n >= Date.parse(o.start) && n < Date.parse(o.end);
  }
  function std(k) { return (k.variants.filter(function (v) { return /standard/i.test(v.title); })[0] || k.variants[0]).price; }
  function off(k) { return offerActive() ? Math.round(std(k) * ((C.offer && C.offer.percent) || 20) / 100) : 0; }
  function track(n, d) { try { if (window.__mugReleaseTrack) return window.__mugReleaseTrack(n, d); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: n }, d)); } catch (e) {} }

  function slot() {
    var cart = document.getElementById('rebuy-cart'); if (!cart) return null;
    var s = document.getElementById('mr-cart-slot');
    if (s && cart.contains(s)) return s;
    var a = cart.querySelector('.rebuy-cart__flyout-recommendations') || cart.querySelector('.rebuy-cart__flyout-footer');
    if (!a || !a.parentNode) return null;
    s = document.createElement('div'); s.id = 'mr-cart-slot'; a.parentNode.insertBefore(s, a); return s;
  }
  var lastShown = '', busy = false, timer = null, seq = 0;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 160); }
  function render() {
    var mine = ++seq;   // a slower, older response must never overwrite a newer one
    fetch('/cart.js?mr=1&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (mine !== seq) return;
        var s = slot(); if (!s || !cart) return;
        var items = cart.items || [];
        var hasMug = items.some(function (i) { return mugIds.indexOf(i.variant_id) > -1; });
        var inCartProducts = {}, inCartVariants = {};
        items.forEach(function (i) {
          if (i.product_id != null) inCartProducts[String(i.product_id)] = true;
          var variantId = i.variant_id != null ? i.variant_id : i.id;
          if (variantId != null) inCartVariants[String(variantId)] = true;
        });
        var ks = C.keychains.filter(function (k) {
          var alreadyInCart = inCartProducts[String(k.productId)] || (k.variants || []).some(function (v) { return inCartVariants[String(v.id)]; });
          return !alreadyInCart && k.variants.some(function (v) { return v.available; });
        });
        if (!hasMug || !ks.length) { s.innerHTML = ''; return; }
        var sig = ks.map(function (k) { return k.key; }).join(',');
        var live = offerActive();
        s.innerHTML = '<div class="mr-cx" role="region" aria-label="Key chains to go with your cups">' +
          '<p class="mr-cx-h">' + (live ? 'Launch-day addition' : 'With your cups') + '</p>' +
          '<p class="mr-cx-s">' + (live ? 'Save ' + money(off(ks[0])) + ' on each matching key chain with your cups today.' : 'The matching key chains.') + '</p>' +
          ks.map(function (k) {
            var dv = k.variants.filter(function (v) { return /standard/i.test(v.title) && v.available; })[0] || k.variants.filter(function (v) { return v.available; })[0];
            var o = off(k);
            return '<div class="mr-cx-row" data-k="' + k.key + '"><img src="' + esc(k.image || '') + '" alt="" width="52" height="52" loading="lazy">' +
              '<div><div class="mr-cx-n">' + esc(k.name) + '</div><div class="mr-cx-p">' + (o ? money(std(k) - o) + '<s>' + money(std(k)) + '</s>' : money(std(k))) + '</div></div>' +
              '<button type="button" class="mr-cx-b">+ Add</button>' +
              '<select aria-label="Packaging">' + k.variants.map(function (v) { return '<option value="' + v.id + '"' + (dv && v.id === dv.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + ' · ' + money(v.price - (v.available ? o : 0)) + (v.available ? '' : ' (sold out)') + '</option>'; }).join('') + '</select></div>';
          }).join('') + '</div>';
        if (sig !== lastShown) { lastShown = sig; track('keychain_upsell_shown', { context: 'cart_drawer', offered: sig, offer_active: live }); }
        Array.prototype.forEach.call(s.querySelectorAll('.mr-cx-row'), function (row) {
          var k = C.keychains.filter(function (x) { return x.key === row.getAttribute('data-k'); })[0];
          row.querySelector('.mr-cx-b').addEventListener('click', function (e) {
            if (busy) return; busy = true;
            var b = e.currentTarget; b.disabled = true; b.textContent = 'Adding…';
            var id = parseInt(row.querySelector('select').value, 10);
            var v = k.variants.filter(function (x) { return x.id === id; })[0];
            fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _source: 'mug-release-cart-drawer' } }] }) })
              .then(function (r) { return r.ok; })
              .then(function (ok) {
                if (ok) track('keychain_upsell_accepted', { context: 'cart_drawer', keychain: k.key, variant_id: id, packaging: v && v.title });
                var p = window.Rebuy && Rebuy.Cart && Rebuy.Cart.fetchCart ? Rebuy.Cart.fetchCart() : null;
                return Promise.resolve(p);
              })
              .catch(function () {})
              .then(function () { busy = false; schedule(); });
          });
        });
      }).catch(function () {});
  }
  ['rebuy:smartcart.show', 'rebuy:smartcart.ready', 'rebuy:cart.change', 'rebuy:cart.ready', 'rebuy:cart.add', 'mr:cart-updated'].forEach(function (n) {
    document.addEventListener(n, schedule);
  });
  // Rebuy re-renders its drawer with Vue; re-attach if our slot is dropped. Rebuy can arrive late
  // (the page-speed app defers it until the first tap or scroll), so keep looking, cheaply, for 30 minutes.
  var obs = null;
  function observe() {
    if (obs) return true;
    var cart = document.getElementById('rebuy-cart'); if (!cart) return false;
    // Re-check the cart only when its line items change or Vue dropped our slot. The drawer's own
    // sliders mutate constantly; reacting to every mutation would refetch the cart every few seconds.
    var itemsSig = function () { var el = cart.querySelector('[data-smartcart-items]'); return el ? el.children.length + ':' + (el.textContent || '').replace(/\s+/g, '').length : ''; };
    var lastSig = itemsSig();
    obs = new MutationObserver(function () {
      var s = document.getElementById('mr-cart-slot'), now = itemsSig();
      if (!s || !cart.contains(s) || now !== lastSig) { lastSig = now; schedule(); }
    });
    obs.observe(cart, { childList: true, subtree: true });
    schedule(); return true;
  }
  (function watch(n) { if (!observe() && n < 940) setTimeout(function () { watch(n + 1); }, n < 40 ? 500 : 2000); })(0);
})();
